import React, {useContext, useState} from 'react'
import Filter from "../../../statics/assets/icons/filter.svg"
import {SettingTenantContext} from "../context/SettingTenantContext"
import TenantFilter from "./filters/TenantFilter"
import TenantTable from "./data-table/TenantTable"
import {Pagination} from "antd"
import AddTenantParam from "./actions/AddTenantParam"

function SettingTenantPage() {
    const SettingTenantPageContext = useContext(SettingTenantContext)

    const {
        loading, error, filters, onChangeFilter, listTenantParam, setPagination, pagination, total
    } = SettingTenantPageContext

    const [showFilters, toggleFilters] = useState(false)

    const _toggleShowFilter = () => {
        toggleFilters(!showFilters)
    }

    const _onChangePagination = (page, pageSize) => {
        setPagination({
            page: pageSize !== pagination.size ? 1 : page,
            size: pageSize
        })
    }

    return (
        <div className='LeadPage PageDefault position-relative'>
            <div className="PageHeading">
                <h1 className="PageTitle">Quản lý tenant</h1>
                <div className="d-flex align-items-center">
                    <div className={`Filter mr-3 ${showFilters && 'filtersOpen'}`}>
                        <label onClick={_toggleShowFilter}><Filter width={20} height={20}/>Bộ lọc</label>
                    </div>

                    <AddTenantParam/>
                </div>
            </div>

            {
                showFilters && <TenantFilter filters={filters} onChangeFilter={onChangeFilter}/>
            }

            <div className="PagePagination d-flex justify-content-end align-items-center mb-3">
                <div className="total mr-3">Total {total} items</div>
                <Pagination
                    className="PaginationCustom"
                    pageSizeOptions={['20', '50', '100', '200']}
                    total={total}
                    pageSize={pagination.size}
                    current={pagination.page}
                    onChange={_onChangePagination}
                />
            </div>

            <div className="PageTable pb-0">
                <TenantTable
                    loading={loading}
                    error={error}
                    listTenantParam={listTenantParam}
                />
            </div>

            <div className="PagePagination d-flex justify-content-end align-items-center mt-3">
                <div className="total mr-3">Total {total} items</div>
                <Pagination
                    className="PaginationCustom"
                    pageSizeOptions={['20', '50', '100', '200']}
                    total={total}
                    pageSize={pagination.size}
                    current={pagination.page}
                    onChange={_onChangePagination}
                />
            </div>
        </div>
    )
}

export default SettingTenantPage
